<div>
  <h2>Customer Reviews</h2>
  <div *ngFor="let review of reviews" class="review-item">
    <img [src]="review.image" alt="item.name" class="ripple-image">
    <h2>{{review.user}}</h2>
    <!-- Star Rating -->
    <div class="star-rating">
      <ng-container *ngFor="let star of [1,2,3,4,5]">
        <span [class.filled]="star <= review.rating">&#9733;</span>
      </ng-container>
    </div>
    <p>{{review.comment}}</p>
  </div>
</div>